import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Landing } from './pages/Landing';
import { SmartBooking } from './pages/SmartBooking';
import { StepTreatment } from './pages/StepTreatment';
import { StepPatientType } from './pages/StepPatientType';
import { StepTimeSlot } from './pages/StepTimeSlot';
import { StepPatientDetails } from './pages/StepPatientDetails';
import { Confirmation } from './pages/Confirmation';
import { Unauthorized } from './pages/Unauthorized';
import SessionExpired from './pages/SessionExpired';

function App() {
  return (
    <Routes>
      <Route path="unauthorized" element={<Unauthorized />} />
      <Route path="session-expired" element={<SessionExpired />} />
      <Route path=":practiceId" element={<Landing />} />
      <Route path=":practiceId/bookonline/*" element={<BookOnlineRoutes />} />
      <Route path="*" element={<Navigate to="/unauthorized" replace />} />
    </Routes>
  );
}

function BookOnlineRoutes() {
  return (
    <Routes>
      <Route
        path="smart-booking"
        element={
          <ProtectedRoute>
            <SmartBooking />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-1"
        element={
          <ProtectedRoute>
            <StepTreatment />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-2"
        element={
          <ProtectedRoute>
            <StepPatientType />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-3"
        element={
          <ProtectedRoute>
            <StepTimeSlot />
          </ProtectedRoute>
        }
      />
      <Route
        path="step-4"
        element={
          <ProtectedRoute>
            <StepPatientDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="confirmation"
        element={
          <ProtectedRoute>
            <Confirmation />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="step-1" replace />} />
    </Routes>
  );
}

export default App;